import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-dot-loader',
    template: `
      <div class="dot-loader-container" role="presentation">
        <div class="dot-loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    `,
    styles: [`
      .dot-loader-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
  
      .dot-loader {
        display: flex;
        gap: 8px;
      }
  
      .dot {
        width: 12px;
        height: 12px;
        background: white;
        border-radius: 50%;
        animation: bounce 0.5s ease-in-out infinite;
      }
  
      .dot:nth-child(2) {
        animation-delay: 0.1s;
      }
  
      .dot:nth-child(3) {
        animation-delay: 0.2s;
      }
  
      @keyframes bounce {
        0%, 100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-10px);
        }
      }
    `]
  })
  export class DotLoaderComponent implements OnInit{
    ngOnInit(): void {
      
    }
  }

